import { i18n } from '@/lib/i18n'
import { ApiError } from '@/lib/api'

/** Translate an ApiError's server message_key (namespace = first dotted segment). */
export function apiErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const dot = err.messageKey.indexOf('.')
    if (dot > 0) {
      return i18n.t(err.messageKey.slice(dot + 1), { ns: err.messageKey.slice(0, dot) })
    }
    return i18n.t(err.messageKey, { ns: 'errors' })
  }
  return i18n.t('generic', { ns: 'errors' })
}
